import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { throwError } from "rxjs/internal/observable/throwError";
import { catchError } from "rxjs/internal/operators/catchError";

import { RootStore } from "../store/root.store";

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  private rootStore = inject(RootStore);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authHeaders = this.rootStore.userStore.getAuthToken();
    if (authHeaders) {
      req = req.clone({
        headers: req.headers.set("Authorization", `Bearer ${authHeaders}`),
      });
    }

    return next.handle(req).pipe(
      catchError((err) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
          }
          return throwError({
            status: err.status,
            body: err.error,
          });
        }
      }),
    );
  }
}
